/* SIDDAMENT context-aware colour swatches.
   - Server-rendered mode (.sdcs-mobile-wrap[data-sdcs-mode="server"]): just wire
     tooltip + mobile toggle + click navigation.
   - Mount mode (.sdcs-mount): resolve the originating collection (URL/referrer/
     sessionStorage), fetch /collections/<X>/products.json (cap-checked), render
     swatches from it. Falls back to the baked merged group from sd-color-groups.json
     on direct hits, blacklisted/oversized collections, or stale context.
   - Live availability overlay: after rendering (any path), every swatch's OOS
     state is re-resolved live from the Storefront API (token-free, same-origin,
     one batched query per ~40 handles) so it's never stale. The baked/Liquid
     value is just the instant initial paint; live data self-corrects it. */
(function () {
  if (window.__sdcsLoaded) return;
  window.__sdcsLoaded = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sizedImage(url, w) { if (!url) return ''; if (url.indexOf('//') === 0) url = 'https:' + url; return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function getSS(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function setSS(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { } }
  function rmSS(k) { try { sessionStorage.removeItem(k); } catch (e) { } }

  // Capture the originating collection into sessionStorage so it survives reloads
  // and within-grid navigation:
  //   - if current URL is /collections/X/products/Y -> store X
  //   - else if referrer is /collections/X/(anything) on same host -> store X
  //   - else if referrer is same-host but not a collection or product page -> clear
  //   - else leave existing value
  function captureOrigin() {
    var m = location.pathname.match(/^\/collections\/([^\/]+)\/products\//);
    if (m) { setSS('sdcs_origin', m[1]); return; }
    var ref = document.referrer || '';
    if (!ref) return; // direct hit or refresh: keep existing
    try {
      var u = new URL(ref);
      if (u.host !== location.host) return;
      var rm = u.pathname.match(/^\/collections\/([^\/]+)/);
      if (rm) { setSS('sdcs_origin', rm[1]); return; }
      if (!u.pathname.match(/^\/products\//)) rmSS('sdcs_origin');
    } catch (e) { }
  }

  ready(function () {
    captureOrigin();
    // Multiple server-rendered grids can exist on the same page (e.g. petg-v1 has
    // an auto-detected V1 grid + an explicit V2 cross-sell grid).
    document.querySelectorAll('.sdcs-mobile-wrap[data-sdcs-mode="server"]').forEach(function (s) {
      wireInteractions(s);
      attachMobileToggle(s);
    });
    document.querySelectorAll('.sdcs-section-toggle').forEach(wireSectionToggle);
    document.querySelectorAll('.sdcs-mount[data-product-id]').forEach(resolveMount);
    scheduleLiveAvailability();
  });

  // ---- live availability overlay ----------------------------------------
  // Every rendered swatch (baked snapshot, collection JSON, or server Liquid)
  // gets its OOS state re-resolved LIVE from Shopify's Storefront API at view
  // time, so it's never stale regardless of page-cache age or snapshot age.
  // One batched, token-free, same-origin GraphQL request per ~40 handles.
  var SF_VERSION = '2024-10';
  var liveTimer = null;
  var liveResolved = {}; // handle -> true once a live answer has been applied

  function scheduleLiveAvailability() {
    if (liveTimer) clearTimeout(liveTimer);
    // small debounce so multiple async render paths collapse into one sweep
    liveTimer = setTimeout(runLiveAvailability, 80);
  }

  function setSwatchOOS(sw, oos) {
    var title = sw.getAttribute('data-title') || '';
    title = title.replace(/ · Out of stock$/, '');
    if (oos) {
      sw.classList.add('oos');
      if (!sw.querySelector('.sdcs-oos-label')) {
        var d = document.createElement('div');
        d.className = 'sdcs-oos-label';
        d.innerHTML = '<span>Out</span>';
        sw.appendChild(d);
      }
      sw.setAttribute('data-title', title + ' · Out of stock');
    } else {
      sw.classList.remove('oos');
      var lbl = sw.querySelector('.sdcs-oos-label');
      if (lbl) lbl.remove();
      sw.setAttribute('data-title', title);
    }
  }

  function runLiveAvailability() {
    var swatches = [].slice.call(document.querySelectorAll('.sdcs-swatch[data-handle]'));
    if (!swatches.length) return;
    var byHandle = {};
    swatches.forEach(function (sw) {
      var h = sw.getAttribute('data-handle');
      if (h) (byHandle[h] = byHandle[h] || []).push(sw);
    });
    // skip handles already resolved or currently in flight (a later sweep from an
    // async render must not re-query what the first sweep is already fetching)
    var handles = Object.keys(byHandle).filter(function (h) { return !liveResolved[h]; });
    if (!handles.length) return;
    var CHUNK = 40;
    for (var i = 0; i < handles.length; i += CHUNK) {
      queryAvailability(handles.slice(i, i + CHUNK), byHandle);
    }
  }

  function queryAvailability(handles, byHandle) {
    handles.forEach(function (h) { liveResolved[h] = true; }); // mark in-flight immediately
    var q = 'query{' + handles.map(function (h, i) {
      return 'p' + i + ': product(handle:' + JSON.stringify(h) + '){availableForSale}';
    }).join(' ') + '}';
    fetch('https://' + location.hostname + '/api/' + SF_VERSION + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: q }),
      credentials: 'omit',
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.data) throw new Error('no data');
        handles.forEach(function (h, i) {
          var node = j.data['p' + i];
          if (node == null) return; // unknown/unpublished handle: keep baked value
          var oos = node.availableForSale === false;
          (byHandle[h] || []).forEach(function (sw) { setSwatchOOS(sw, oos); });
        });
      })
      .catch(function () { handles.forEach(function (h) { delete liveResolved[h]; }); });
  }

  function wireSectionToggle(btn) {
    var sec = btn.closest('.sdcs-section');
    if (!sec) return;
    var expandedLabel = btn.getAttribute('data-expanded-label') || 'Hide';
    var collapsedLabel = btn.getAttribute('data-collapsed-label') || 'Show';
    btn.addEventListener('click', function () {
      var collapsed = sec.classList.toggle('collapsed');
      btn.textContent = collapsed ? collapsedLabel : expandedLabel;
    });
  }

  // ---- shared interactions (server-rendered AND JS-rendered grids use these) ----
  function ensureTooltip() {
    var t = document.getElementById('sdcs-global-tooltip');
    if (!t) { t = document.createElement('div'); t.id = 'sdcs-global-tooltip'; document.body.appendChild(t); }
    return t;
  }
  function positionTip(el, tip) {
    // hover scale must mirror .sdcs-swatch:hover in sd-color-swatches.css
    var scale = window.matchMedia('(max-width: 480px)').matches ? 1.15
              : window.matchMedia('(max-width: 749px)').matches ? 1.3 : 2;
    var r = el.getBoundingClientRect();
    var tipH = tip.offsetHeight;
    // the scale transform is centre-origin, so the centre never moves; the rect
    // height is unreliable (already scaled on mousemove) but offsetHeight is layout size
    var visualTop = (r.top + r.height / 2) - (el.offsetHeight * scale) / 2;
    tip.style.left = (r.left + r.width / 2) + 'px';
    tip.style.top = (visualTop - tipH - 6) + 'px';
  }
  function wireInteractions(container) {
    var tip = ensureTooltip();
    container.querySelectorAll('.sdcs-swatch').forEach(function (sw) {
      var go = function () {
        var url = sw.getAttribute('data-url');
        if (!url) { var h = sw.getAttribute('data-handle'); if (h) url = '/products/' + h; }
        if (url) window.location.href = url;
      };
      sw.addEventListener('click', go);
      sw.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      sw.addEventListener('mouseenter', function () { var t = this.getAttribute('data-title'); if (!t) return; tip.textContent = t; tip.classList.add('visible'); positionTip(this, tip); });
      sw.addEventListener('mousemove', function () { positionTip(this, tip); });
      sw.addEventListener('mouseleave', function () { tip.classList.remove('visible'); });
    });
  }
  function attachMobileToggle(container) {
    var grid = container.querySelector('.sdcs-grid');
    if (!grid || container.querySelector('.sdcs-toggle-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sdcs-toggle-btn';
    btn.innerHTML = '<span class="sdcs-toggle-text">Show all colours</span><span class="sdcs-toggle-icon">▼</span>';
    var COOKIE = 'nm_expanded';
    function setExpanded(e) {
      var t = btn.querySelector('.sdcs-toggle-text');
      if (e) { grid.classList.remove('collapsed'); btn.classList.add('expanded'); t.textContent = 'Show less'; setCookie(COOKIE, '1', 365); }
      else { grid.classList.add('collapsed'); btn.classList.remove('expanded'); t.textContent = 'Show all colours'; setCookie(COOKIE, '0', 365); }
    }
    btn.addEventListener('click', function () { setExpanded(grid.classList.contains('collapsed')); });
    container.appendChild(btn);
    if (window.innerWidth <= 480) setExpanded(getCookie(COOKIE) === '1');
    // no-op toggle guard: if the full grid fits inside the collapsed cap
    // (120px + border slack), there is nothing to expand — show the grid
    // fully and drop the button entirely
    requestAnimationFrame(function () {
      if (grid.scrollHeight <= 124) {
        grid.classList.remove('collapsed');
        btn.remove();
      }
    });
  }
  function getCookie(name) { var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; }
  function setCookie(name, value, days) { var exp = new Date(Date.now() + days * 864e5).toUTCString(); document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + exp + '; path=/'; }

  // ---- mount mode: origin -> /collections/X/products.json, else baked ----
  function fetchAllCollectionProducts(origin, maxPages) {
    var all = [];
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(origin) + '/products.json?limit=250&page=' + n, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (j) {
          var prods = (j && j.products) || [];
          all = all.concat(prods);
          if (prods.length === 250 && n < maxPages) return page(n + 1);
          return all;
        });
    }
    return page(1);
  }
  function resolveMount(mount) {
    var origin = getSS('sdcs_origin');
    var blacklist = (mount.getAttribute('data-blacklist') || '').split(',').map(function (s) { return s.trim(); });
    var currentHandle = mount.getAttribute('data-product-handle');
    if (origin && blacklist.indexOf(origin) < 0) {
      fetchAllCollectionProducts(origin, 8)
        .then(function (prods) {
          if (prods.length <= 1 || prods.length > 2000) throw new Error('size');
          if (!prods.some(function (p) { return p.handle === currentHandle; })) throw new Error('stale');
          renderFromCollection(mount, origin, prods, currentHandle);
        })
        .catch(function () { renderBaked(mount); });
      return;
    }
    renderBaked(mount);
  }

  var hugeCSSInjected = false;
  function applyHugeGrid(grid) {
    if (!grid || grid.children.length <= 120) return;
    if (!hugeCSSInjected) {
      hugeCSSInjected = true;
      var st = document.createElement('style');
      st.textContent = '.sdcs-grid.sdcs-scroll{max-height:46vh;overflow-y:auto;overscroll-behavior:contain;padding-right:6px;}'
        + '.sdcs-grid.sdcs-scroll::-webkit-scrollbar{width:6px;}'
        + '.sdcs-grid.sdcs-scroll::-webkit-scrollbar-thumb{background:rgba(255,255,255,.25);border-radius:3px;}';
      document.head.appendChild(st);
    }
    grid.classList.add('sdcs-scroll');
  }
  function buildWrap(mode, key) {
    var w = document.createElement('div');
    w.className = 'sdcs-mobile-wrap';
    w.setAttribute('data-sdcs-mode', mode);
    w.setAttribute('data-sdcs-key', key);
    var g = document.createElement('div'); g.className = 'sdcs-grid';
    w.appendChild(g);
    return w;
  }

  function renderFromCollection(mount, originHandle, products, currentHandle) {
    var wrap = buildWrap('collection', originHandle);
    var grid = wrap.querySelector('.sdcs-grid');
    var html = '';
    products = products.slice().sort(function (a, b) {
      var A = (a.variants && a.variants.some(function (v) { return v.available; })) ? 0 : 1;
      var B = (b.variants && b.variants.some(function (v) { return v.available; })) ? 0 : 1;
      return A - B;
    });
    products.forEach(function (p) {
      // Shopify /collections/X/products.json shape: no top-level `available`/`featured_image`;
      // images is an array of objects with .src; availability derived from variants[].available.
      var available = !!(p.variants && p.variants.some(function (v) { return v.available; }));
      var oos = !available;
      var isCur = p.handle === currentHandle;
      var imgObj = (p.images && p.images[0]) || null;
      var imgSrc = (typeof p.featured_image === 'string' ? p.featured_image : (imgObj && (imgObj.src || imgObj))) || '';
      var bg = typeof imgSrc === 'string' ? sizedImage(imgSrc, 200) : '';
      html += '<div class="sdcs-swatch' + (oos ? ' oos' : '') + (isCur ? ' current' : '') + '"'
        + ' style="background-image:url(\'' + esc(bg) + '\');"'
        + ' role="button" tabindex="0"'
        + ' data-handle="' + esc(p.handle) + '"'
        + ' data-url="/collections/' + encodeURIComponent(originHandle) + '/products/' + esc(p.handle) + '"'
        + ' data-title="' + esc(p.title) + (oos ? ' · Out of stock' : '') + '">'
        + '<span class="sdcs-fill" aria-hidden="true"></span>'
        + (oos ? '<div class="sdcs-oos-label"><span>Out</span></div>' : '')
        + '</div>';
    });
    grid.innerHTML = html;
    applyHugeGrid(grid);
    mount.replaceWith(wrap);
    wireInteractions(wrap);
    attachMobileToggle(wrap);
    scheduleLiveAvailability();
  }

  function bakedFail(mount) {
    var fb = mount.getAttribute('data-fallback-collection');
    var currentHandle = mount.getAttribute('data-product-handle');
    if (fb) {
      fetchAllCollectionProducts(fb, 8)
        .then(function (prods) {
          if (prods.length <= 1) throw new Error('size');
          renderFromCollection(mount, fb, prods, currentHandle);
        })
        .catch(function () { mount.remove(); });
      return;
    }
    mount.remove();
  }
  function renderBaked(mount) {
    var dataUrl = mount.getAttribute('data-data-url');
    var pid = String(mount.getAttribute('data-product-id'));
    // Cache-bust by 5-minute bucket: works around stale page-cache emitting an
    // outdated asset_url ?v=hash that the CDN keeps serving forever. Each new
    // bucket -> unique URL -> CDN re-fetches origin (which has the latest data);
    // requests within the same 5-min window still hit the CDN cache for speed.
    var bucket = Math.floor(Date.now() / 300000);
    dataUrl += (dataUrl.indexOf('?') >= 0 ? '&' : '?') + '_t=' + bucket;
    fetch(dataUrl, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var gid = data.productToGroup && data.productToGroup[pid];
        if (gid == null) { bakedFail(mount); return; }
        var group = data.groups && data.groups[gid];
        if (!group || !group.products || group.products.length < 2) { bakedFail(mount); return; }
        var wrap = buildWrap('baked', String(gid));
        var grid = wrap.querySelector('.sdcs-grid');
        var html = '';
        var bakedSorted = group.products.slice().sort(function (a, b) {
          return ((a.available === false) ? 1 : 0) - ((b.available === false) ? 1 : 0);
        });
        bakedSorted.forEach(function (p) {
          var oos = p.available === false;
          var isCur = String(p.id) === pid;
          var bg = sizedImage(p.image, 200);
          var styles = "background-image:url('" + esc(bg) + "');";
          if (p.hex && p.hex.indexOf('|') === -1) styles += 'background-color:' + esc(p.hex) + ';';
          html += '<div class="sdcs-swatch' + (oos ? ' oos' : '') + (isCur ? ' current' : '') + '"'
            + ' style="' + styles + '"'
            + ' role="button" tabindex="0"'
            + ' data-handle="' + esc(p.handle) + '"'
            + ' data-url="/products/' + esc(p.handle) + '"'
            + ' data-title="' + esc(p.name) + (oos ? ' · Out of stock' : '') + '">'
            + '<span class="sdcs-fill" aria-hidden="true"></span>'
            + (oos ? '<div class="sdcs-oos-label"><span>Out</span></div>' : '')
            + '</div>';
        });
        grid.innerHTML = html;
        applyHugeGrid(grid);
        mount.replaceWith(wrap);
        wireInteractions(wrap);
        attachMobileToggle(wrap);
        scheduleLiveAvailability();
      })
      .catch(function () { bakedFail(mount); });
  }
})();
